// @flow
import React, { useContext } from 'react';

import { StyledInputWithAccessibility } from '../../common-utils/styledComponents';
import { isLastElementInArray } from '../../common-utils/utils';
import { TinyHeaderSpan } from '../presentational/headings/TinyHeaderSpan';
import { TextField } from '../../formik-utils/FormFields';
import { TEXT_NUMBER_INPUT_TYPE } from '../../formik-utils/consts';
import {
  ADVANCED_SECURITY_TIER_END_BACKEND_NAME,
  ADVANCED_SECURITY_USAGE_PERCENTAGE_BACKEND_NAME,
} from '../../constants';
import { FixedRowsGridRowContext } from '../../formik-utils/FixedRowsGrid';

import { ADVANCED_SECURITY_TIER_END_INFINITY_PLACEHOLDER } from './constants';
import { getPathToTier, getTierStart } from './utils';

// "Tier N" label, derived from the row index.
export const TierLabelCell = () => {
  const { rowIndex } = useContext(FixedRowsGridRowContext);

  return <TinyHeaderSpan headerText={`Tier ${rowIndex + 1}`} />;
};

// Per-tier usage percentage (editable).
export const UsagePercentageCell = () => {
  const { readOnly, rowIndex } = useContext(FixedRowsGridRowContext);

  return (
    <TextField
      addLabel={false}
      disabled={readOnly}
      fieldName={ADVANCED_SECURITY_USAGE_PERCENTAGE_BACKEND_NAME}
      icon="percent"
      iconPosition="right"
      pathToFollowInValues={getPathToTier(rowIndex)}
      type={TEXT_NUMBER_INPUT_TYPE}
    />
  );
};

// Tier N's start = Tier N-1's end; always derived, never entered, so it is a read-only input.
export const TierStartCell = () => {
  const { rowIndex, rows } = useContext(FixedRowsGridRowContext);

  return (
    <StyledInputWithAccessibility
      disabled={true}
      fluid={true}
      icon="dollar"
      iconPosition="right"
      value={getTierStart(rows, rowIndex)}
    />
  );
};

// Editable tier end — except the last tier, which always extends to Infinity (disabled placeholder).
export const TierEndCell = () => {
  const { readOnly, rowIndex, rows } = useContext(FixedRowsGridRowContext);

  if (isLastElementInArray(rows, rowIndex)) {
    return (
      <StyledInputWithAccessibility
        disabled={true}
        fluid={true}
        placeholder={ADVANCED_SECURITY_TIER_END_INFINITY_PLACEHOLDER}
      />
    );
  }

  return (
    <TextField
      addLabel={false}
      disabled={readOnly}
      fieldName={ADVANCED_SECURITY_TIER_END_BACKEND_NAME}
      icon="dollar"
      iconPosition="right"
      pathToFollowInValues={getPathToTier(rowIndex)}
      // A tier's end validity depends on the previous tier's end, so editing one tier can
      // invalidate another. Surface the error whenever it exists — not only when this specific
      // field was touched — otherwise the error stays hidden on the untouched dependent tier.
      showErrorsOnlyWhenTouched={false}
      type={TEXT_NUMBER_INPUT_TYPE}
    />
  );
};
